import {QuoteServiceSummary} from "./quote-service-summary";

export class ServiceLineSummary {

    public code: string;
    public label: string;
    public appliedPrice: string;
    public monthlyAmount: string;
    public weeklyAmount: string;
    public view: string;
    public newQuoteService?: QuoteServiceSummary;
    public renewalQuoteService?: QuoteServiceSummary;

    constructor(code: string, label: string, appliedPrice: string, monthlyAmount: string, weeklyAmount: string, view: string, newQuoteService?: QuoteServiceSummary, renewalQuoteService?: QuoteServiceSummary) {
        this.code = code;
        this.label = label;
        this.newQuoteService = newQuoteService;
        this.renewalQuoteService = renewalQuoteService;
        this.appliedPrice = appliedPrice;
        this.weeklyAmount = weeklyAmount;
        this.monthlyAmount = monthlyAmount;
        this.view = view;
    }
}
